let StoreLocator = {};
var cartAjaxRequestEnable = true;
var selectedLocation = '';
var searchString = '';

StoreLocator.init = function() {
  let locationFilter = $('.js-store-locator-location');
  locationFilter.on( 'click', function() {
    let selectedValue = $(this).attr('data-value');
    selectedLocation = selectedValue;
    let data = {
      'action': 'store_locator_search',
      'location': selectedValue,
    };

    if( searchString.length > 0 ) {
      data.city = searchString;
    }
    locationFilter.removeClass('btn-primary').addClass('btn-secondary');
    $(this).removeClass('btn-secondary').addClass('btn-primary');
    StoreLocator.ajaxCall( data );
  });

  // catch on enter
  let searchButton = $('#js-search-locator-button');
  let searchText = $('#js-search-locator-string');

  searchButton.on( 'click', function() {
    searchString =  $.trim(searchText.val());
    if( searchString.length == 0 && selectedLocation.length == 0 ) {
      return false;
    }
    
    let data = {
      'action': 'store_locator_search',
    };

    if( searchString.length > 0 ) {
      data.city = searchString;
    }
    if( selectedLocation.length > 0 ) {
      data.location = selectedLocation;
    }
    StoreLocator.ajaxCall( data );
  });

  searchText.on( 'keypress', function( e ) {
    if (e.keyCode == 13) {
      searchButton.trigger( 'click' );
    }
  });
}

StoreLocator.ajaxCall = function( data ) {
  // To avoid double send of ajax request
  if (!cartAjaxRequestEnable) {
      return;
  }

  $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: data,
      type: 'POST',
      dataType: 'json',
      beforeSend: function () {
        cartAjaxRequestEnable = false;
      },
      success: function (result) {
        $('#js-store-locator-search-result').html(result.html);
      },
      complete: function () {
          cartAjaxRequestEnable = true;           
      },
      error: function (request) {
          console.debug(request);
      },
  });
};

StoreLocator.init();



// WEBPACK FOOTER //
// ./scripts/components/store-locator.js